export default __webpack_public_path__ + "static/media/Hitfic.373e26df.png";